import React,{useRef, useState, useEffect} from "react";
import {Form, Col, Row } from "react-bootstrap";

class OpacityPanel extends React.Component {

	
	constructor(props) {
		super(props);
		
		
		this.props.du.op = this;
		
		this.opacityPanel = React.createRef();
		
		
		this.state = {

		};
		
	}
	setOpacity(value){
		var x = {...this.state, ...{opacity: value}};
		this.setState(x);
		this.forceUpdate();
	}
	setLegend(value){
		var x = {...this.state, ...{legend: value}};
		this.setState(x);
		this.forceUpdate();
	}

	handleOpacityChange = (opc) => {

		var opacity = parseFloat(opc);
		this.setOpacity(opacity);
		
		if(this.props.onOpacityChange)
			this.props.onOpacityChange(opacity);
		
	};

	render() {
		return (
			<div className="opacity-panel" ref={this.optionsPanel} >
				<Row>
					<Col xs="12">
						<b>Layer transparency</b>
					</Col>
					<Col xs="12 px-0 pt-2 mt-3">
						<Form.Range className="opacity-range-input" min="0" max="1" step=".01" value={this.state.opacity} defaultValue={this.state.opacity} onChange={(e)=>{this.handleOpacityChange(e.target.value);}} />
					</Col>
					{this.state.legend && 
					<Col xs="12 legend px-0 pt-2 mt-3">
						<img src={this.state.legend} />
					</Col>
					}
				</Row>
			</div>	
		);
	}
}

export default OpacityPanel;